import { getUrlParam } from './util';
const ua = typeof window !== 'undefined' ? navigator.userAgent : '';

export const inYoda = ua.includes('Yoda/');
export const useTitle = getUrlParam('useTitle');
